import React from 'react';
import { motion } from 'framer-motion';
import styles from './ScheduleCfpSessionPage.module.css';

function CfpSegmentTabs({ segments, activeSegmentId, onSegmentChange }) {
  return (
    <div className={styles.tabsScrollWrap} role="tablist" aria-label="Session experience segments">
      <div className={styles.tabsRow}>
        {segments.map((segment) => {
          const isActive = segment.id === activeSegmentId;
          return (
            <button
              key={segment.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              id={`cfp-tab-${segment.id}`}
              aria-controls={`cfp-tabpanel-${segment.id}`}
              className={`${styles.tab} ${isActive ? styles.tabActive : ''}`}
              onClick={() => onSegmentChange(segment.id)}
            >
              {isActive && (
                <motion.span
                  layoutId="cfp-tab-indicator"
                  className={styles.tabActiveBg}
                  transition={{ type: 'spring', stiffness: 380, damping: 32 }}
                />
              )}
              <span className={styles.tabLabel}>{segment.label}</span>
              <span className={`${styles.tabCount} ${isActive ? styles.tabCountActive : ''}`}>
                {segment.topics.length}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default CfpSegmentTabs;
